module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"G-HKTRN36RJ8","head":true,"anonymize":true,"pageTransitionDelay":1000,"enableWebVitalsTracking":true,"defer":false,"respectDNT":false,"exclude":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"#ffffff"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Light | Nexo 3/2021","short_name":"Light","description":"Texts on light and lightness by Nexo’s writers explore parenthood, prejudice, and courageousness. Read thought-provoking texts by a diverse community of writers.","background_color":"#000000","theme_color":"#ffffff","icon":"static/favicon.svg","start_url":"/","display":"browser","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"1ba29e966eb8120dada8237203967e4f"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
